import { ILanguageService } from "../../service/language/LanguageService";
import { ICredentialsService } from "../../service/authentication/CredentialsService";
import { IAsyncLocaleProvider } from "../../service/locale/AsyncLocaleProvider";

export default class ChangeLanguageInteractor {
  private languageService: ILanguageService;
  private credentialsService: ICredentialsService;
  private localeProvider: IAsyncLocaleProvider;

  constructor(languageService, credentialsService, localeProvider) {
    this.languageService = languageService;
    this.credentialsService = credentialsService;
    this.localeProvider = localeProvider;
  }

  async execute(languageCode: number, isPortalActive: boolean = false) {
    if (!isPortalActive) {
      await this.languageService.changeLanguage(languageCode);
    }

    this.credentialsService.setLanguage(languageCode);
    const translations = await this.localeProvider.fetch(languageCode);
    this.localeProvider.addLocale(languageCode, translations);
    this.localeProvider.changeCurrentLanguage(languageCode);
  }
}
